export default {
  getDiscounts: (state) => state.discounts.list.items,
  getDiscountsPaginationData: (state) => state.discounts.list.meta,
  getDiscountsIsFetching: (state) => state.discounts.list.isFetching,
};
